import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface IPackagePeriodResponse {
    status: boolean;
    status_code: number;
    message: string;
    data: string[];
}

export const ListPackagePeriodSlice = createSlice({
    name: "ListPackagePeriodSlice",
    initialState: {} as IReduxState<IPackagePeriodResponse>,
    reducers: {
        listPackagePeriod: (state) => {
            state.isLoading = true;
        },
        successlistPackagePeriod: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistPackagePeriod: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
    },
});

export const {
    listPackagePeriod,
    successlistPackagePeriod,
    failurelistPackagePeriod,
} = ListPackagePeriodSlice.actions;

export default ListPackagePeriodSlice.reducer;
